import type { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

import { isPublicSharePath } from '../publicRoutes';
import { resetClientAuthState } from './resetClientAuthState';

export function register401Interceptor(api: AxiosInstance): void {
  api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        resetClientAuthState();

        if (typeof window !== 'undefined') {
          const { pathname } = window.location;
          const isAuthRoute = pathname.startsWith('/auth/');

          if (
            !isAuthRoute &&
            !pathname.includes('/auth/login') &&
            !isPublicSharePath(pathname)
          ) {
            window.location.href = '/auth/login';
          }
        }
      }

      return Promise.reject(error);
    },
  );
}
